import React from "react";
import {
  Button,
  ConfigProvider,
  Radio,
  RadioChangeEvent,
  Typography,
} from "antd";
import moment from "moment";
import { TNotification, TNotifications } from "./notificationBlock.interface";
import {
  clearAllNotifications,
  readNotification,
} from "../../../api/notifications/notifications";

const radioThemeConfig = {
  components: {
    Radio: {
      colorPrimary: "#580086",
      colorPrimaryActive: "#580086",
      colorPrimaryHover: "#580086",
    },
    Button: {
      colorPrimary: "#580086",
      colorPrimaryActive: "#580086",
      colorPrimaryHover: "#580086",
    },
  },
};

function NotificationBlock({
  notifications,
  setNotificationFilter,
  refetch,
  setClose,
}: {
  notifications: TNotifications;
  setNotificationFilter: (value: any) => void;
  refetch: () => void;
  setClose: () => void;
}) {
  const onChange = (e: RadioChangeEvent) => {
    setNotificationFilter(e.target.value);
  };

  const handleReadNotification = async (id: string) => {
    try {
      await readNotification(id);
      refetch();
    } catch (error) {
      console.log(error);
    }
  };

  const handleClearAll = async () => {
    try {
      await clearAllNotifications();
      refetch();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section className="bg-white grid gap-4  p-2">
      <div>
        <div className="flex items-center justify-between">
          <Typography.Title className="text-appcolorblackfaint" level={4}>
            Notifications
          </Typography.Title>

          <img
            src="/img/vectors/xcrosspurple.svg"
            alt="close-notification"
            className="cursor-pointer"
            onClick={setClose}
          />
        </div>
        <div className="flex justify-between gap-2 leading-tight">
          <ConfigProvider theme={radioThemeConfig}>
            <Radio.Group
              onChange={onChange}
              defaultValue="all"
              buttonStyle="solid"
              size="small"
            >
              <Radio.Button value="all">All</Radio.Button>
              <Radio.Button value={false}>Unread</Radio.Button>
            </Radio.Group>
          </ConfigProvider>

          <Button
            type="primary"
            size="small"
            className="text-white bg-appcolorpurpleseven hover:!bg-appcolorpurpletwo active:!bg-appcolorpurpletwo"
            onClick={handleClearAll}
          >
            Clear all
          </Button>
        </div>
      </div>
      <div>
        {notifications.length === 0 ? (
          <div className="flex items-center justify-center">
            <Typography.Text className="text-appcolorblackfaint">
              No notifications
            </Typography.Text>
          </div>
        ) : (
          notifications.map((notification) => (
            <NotificationItem
              key={notification._id}
              {...notification}
              handleReadNotification={handleReadNotification}
            />
          ))
        )}
      </div>
    </section>
  );
}

export default NotificationBlock;

const NotificationItem = React.memo(function NotificationItem({
  title,
  createdAt,
  description,
  isRead,
  link,
  _id,
  handleReadNotification,
}: TNotification & { handleReadNotification: (id: string) => void }) {
  return (
    <div
      className={`grid cursor-pointer rounded px-3 py-2 ${
        !isRead ? "bg-appcolordeeppurpletwo/5" : ""
      }`}
      onClick={() => handleReadNotification(_id)}
    >
      <div className="flex items-center justify-between">
        <Typography.Text strong className="text- text-appcolordeeppurpletwo">
          {title}
        </Typography.Text>
        {!isRead ? (
          <span className="h-2 w-2 rounded bg-appcolorpurpleseight/80"></span>
        ) : null}
      </div>
      <Typography.Text className="text-sm opacity-80">
        {description}
      </Typography.Text>
      <Typography.Text className="font-quicksand text-xs">
        {moment(createdAt).fromNow()}
      </Typography.Text>
    </div>
  );
});
